import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    color: "#606479 !important", 
    backgroundColor: "transparent !important",
    borderColor: "#6C65D9 !important"
  }
}));
export default useStyles;
